<template>
<div>
    <div v-if="currentFile" class="progress mb-2">
      <div
        class="progress-bar progress-bar-info progress-bar-striped"
        role="progressbar"
        :aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="{ width: progress + '%' }"
      >
        {{ progress }}%
      </div>
    </div>

	<div>
        <!-- Input + Browse button layout similar to b-form-file -->
        <div class="custom-file-wrapper mb-2">
            <div class="input-group">
                <input type="text" class="form-control" :value="selectedFileName" readonly :placeholder="txtslfile" style="border-radius: 25px 0 0 25px !important;">
                <div class="input-group-append">
                    <button class="btn btn-primary" type="button" @click="choseUpload()">{{ browseButtonText }}</button>
                </div>
            </div>
            <input type="file" id="file_0" ref="file_0" @change="selectFile(0)" style="display:none">
        </div>

        <!-- Messages -->
        <div v-if="message" class="small mb-2" :class="{'text-info': !isUploadError, 'text-danger': isUploadError}">
            {{ message }}
        </div>

        <!-- Upload button -->
        <div class="mb-2">
            <button class="btn btn-primary" type="button" :disabled="true" ref='upplbutt_0' @click="upload(0)">{{ txtupload }}</button>
        </div>

        <!-- Upload message -->
        <div v-if="messageupload" class="small text-info">
            {{ messageupload }}
        </div>
  	</div>
  </div>
</template>

<script>

import UploadService from "./upload_service";

//const Allowedfiletypes = ['text/csv','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/pdf','image/jpeg', 'image/png'];
const Allowedfiletypes = ['application/pdf'];
const numUploads = 2; 
function saveafter(obj) {
	
	obj.$refs.form_submit.click();
	
}
export default {
  name: "upload-files",
  props: ['text_field','rid','formn','pageObj','shortname'],
  data() {
    return {
	  selectedFiles: undefined,
      currentFile: undefined,
      progress: 0,
      message: this.$t('riportalApp.researchInfrastructure.upload.allowedtypes') + " / " + this.$t('riportalApp.researchInfrastructure.upload.namecontent'),
      messageupload: '',
      isUploadError: false,
      fileInfos: [],
      filetype:"",
      filenameout:"",
      selectedFileName: "",
      txtslfile:this.$t('riportalApp.researchInfrastructure.upload.txtslfile'),
      txtupload:this.$t('riportalApp.researchInfrastructure.upload.txtupload'),
      browseButtonText: this.$t('riportalApp.researchInfrastructure.upload.txtslfile'),
      filetypes:this.$t('riportalApp.researchInfrastructure.upload.allowedtypes'),
      sucss : false,
      uploadFiles:[],
      upfile:'',
      obj:null

    };
  },
  methods: {
	choseUpload() {
		//// console.log('choseUpload')
		this.$refs['file_0'].click();
	},  
  	selectFile(i) {
      this.isUploadError = false;
      this.progress = 0;
      this.uploadFiles = new Array();
      this.selectedFiles = new Array();
      const refName = 'file_' + i;
      this.upfile = this.$refs[refName].files[0];
      const filename = this.upfile.name;
      var fname = filename.substr(0, filename.lastIndexOf('.'));
      this.filenameout = filename;
      this.selectedFileName = filename;
	  if (/^[A-Za-z0-9]*$/.test(fname) != true)
      {
        this.message =  this.$t('riportalApp.researchInfrastructure.upload.namecontent');
        this.$refs['upplbutt_'+i].disabled = true;
        this.isUploadError = true;
        this.selectedFileName = "";
        return;
      }
      if (Allowedfiletypes.includes(this.upfile.type) != true) {
        this.message = this.$t('riportalApp.researchInfrastructure.upload.badtypeupload') + this.upfile.name;
        this.isUploadError = true;
        this.selectedFileName = "";
      } else {
        this.selectedFiles = this.$refs[refName].files[0];
        this.$refs['upplbutt_'+i].disabled = false;
        const index = this.uploadFiles.indexOf(this.selectedFiles); // 👉️  0
        if (index !== -1) {
          this.uploadFiles[index] = this.selectedFiles;
        } else if (this.uploadFiles.length == numUploads ) {
          this.uploadFiles[i] = this.selectedFiles
        } else
          this.uploadFiles.push(this.selectedFiles)
          // console.log(this.formn);
	  		this.pageObj[this.text_field] = this.filenameout;
	  		this.message = '';
       		this.messageupload = '';
      }
    },
    upload(i) {
	   //// console.log('upload');
	  this.progress = 0;
      this.currentFile = this.uploadFiles[i];
      const filename =  this.currentFile.name;
      var fname = filename.substr(0, filename.lastIndexOf('.'));
      var fext = filename.substr(filename.length-4);
      const newname = this.shortname + "_"+ this.pageObj.id + '_' + fname + fext ;
      const nfl = UploadService.renameFile(this.currentFile,newname);
      this.upfile = nfl;
      this.pageObj[this.text_field]=this.upfile.name;
      UploadService.upload(nfl, event => {
        this.progress = Math.round((100 * event.loaded) / event.total);
      })
        .then(response => {
		   this.messageupload = response.data.message;
	       this.messageupload = this.$t('riportalApp.researchInfrastructure.upload.uploaded') + this.upfile.name;
          // this.$notify({text:JSON.stringify(this.$t('riportalApp.researchInfrastructure.upload.uploaded') + " " + this.upfile.name).replace(/["]/g, ''), type:'info', duration:5000});
           this.selectedFileName = "";
           // setTimeout(saveafter,0,this.formn); // Commented out: Don't auto-submit form after file upload
         })
        .catch(() => {
		  this.progress = 0;
          this.messageupload = this.$t('riportalApp.researchInfrastructure.upload.badupload');
         // this.$notify({text:JSON.stringify(this.$t('riportalApp.researchInfrastructure.upload.badupload') + " " + this.upfile.name).replace(/["]/g, ''), type:'error', duration:5000});
          this.currentFile = undefined;
        });
       // this.$refs['upplbutt_'+i].disabled = true;
    },
    created() {
		
  	},
    mounted() {
		
  	}},
  	
  };
</script>

<style>

.no-error-color {
  color: #0d6efd;
}

.error-color {
  color: red;
}

</style>